import { AxiosError } from "axios";
import customAxios from "config";

export type ResolveResult =
  | { kind: "ok"; targetUrl: string }
  | { kind: "expired" }
  | { kind: "not_found" }
  | { kind: "error"; message: string };

// Looks up a payment short-link slug on Django. The backend identifies the
// tenant from the request's Host header (which is the rental company's
// custom domain) — no extra context needed from the client.
export const resolveShortLink = async (
  slug: string
): Promise<ResolveResult> => {
  try {
    const response = await customAxios.get("/api/short-links/resolve/", {
      params: { slug },
    });
    const target = response?.data?.target_url;
    if (typeof target === "string" && target.length > 0) {
      return { kind: "ok", targetUrl: target };
    }
    return { kind: "error", message: "Empty target URL" };
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      if (error.response.status === 410) {
        return { kind: "expired" };
      }
      if (error.response.status === 404) {
        return { kind: "not_found" };
      }
      return {
        kind: "error",
        message:
          error.response.data?.detail ?? "Failed to resolve payment link",
      };
    }
    return { kind: "error", message: "Network error" };
  }
};
